export const CREATE_ATTACHMENTS = 'files/CREATE_ATTACHMENTS';
export const UPDATE_ATTACHMENTS = 'files/UPDATE_ATTACHMENTS';
export const GET_LIMIT_OF_UPLOADING_FILE_SIZE = 'files/GET_LIMIT_OF_UPLOADING_FILE_SIZE';
export const MUTATE_CACHE_PROFILE_PICTURE = 'files/MUTATE_CACHE_PROFILE_PICTURE';
export const UPLOAD_PROFILE_PICTURE = 'files/UPLOAD_PROFILE_PICTURE';
export const GET_CREATED_ATTACHMENTS = 'files/GET_CREATED_ATTACHMENTS';
export const MUTATE_CREATED_ATTACHMENTS = 'files/MUTATE_CREATED_ATTACHMENTS';
export const CREATE_DOCUMENT_LINKS = 'files/CREATE_DOCUMENT_LINKS';
